import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate
} from "react-router-dom";

import Home from "./Home/Home.js";
import DevHome from "./Home/DevHome.js";
import People from "./People/People.js";
import Navbar from "./ReusableComponents/Navbar.js";
import Docs from "./Docs/Docs.js"

const RedirectToHome = () => {
    React.useEffect(() => {
        window.location.href = "https://www.desync.ai/home";
    }, []);
    return null;
};

function Components() {
    return (
        <Router>
            <Navbar />
            <Routes>
                {/* <Route path="/" element={<Home />} /> */}
                <Route path="/home" element={<Home />} />
                <Route path="/dev" element={<DevHome />} />
                <Route path="/team" element={<People />} />
                <Route path="/docs" element={<Docs />} />

                {/* <Route path="*" element={<Navigate to="/home" />} /> */}
                <Route path="*" element={<RedirectToHome />} />
            </Routes>
        </Router>
    );
}

export default Components;